import MenuItem from '@mui/material/MenuItem';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { ItemComponentProps} from 'core/components/Elements/DropDown/DropDown';
import { menuItemStyles } from 'core/components/Elements/DropDown/DropDown';
import { startCommand } from 'core/redux/actions/command/commandActions';
import type { AppThunkDispatch } from 'core/redux/store/configureStore.types';
import type React from 'react';
import { useDispatch } from 'react-redux';

function ItemButton({
  item, buttonRef, onClose, selected,
}: ItemComponentProps) {
  const {
    id, title, active,
  } = item;
  const dispatch = useDispatch<AppThunkDispatch>();

  return (
    <li role="menuitem" title={title} aria-disabled={active === false}>
      <MenuItem
        component="button"
        role="button"
        data-e2e-dropdown-item={id}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          onClose(e, buttonRef);
          dispatch(startCommand(item));
        }}
        dense
        disabled={active === false}
        sx={menuItemStyles}
        selected={selected}
      >
        <CommandLinkContent command={item} />
      </MenuItem>
    </li>
  );
}

export default ItemButton;
